// useToastActions.js
import { toast } from "react-toastify";
import {
  DefaultToastOptions,
  NotificationToastOptions,
} from "@maxis/components/components/LoadingIndicator/ToastOption";
import {
  getLoadMsg,
  getRenderMsg,
} from "@maxis/components/components/LoadingIndicator/ToastMessage";
import { useBoundStore } from "@maxis/client-logic/store/useBoundStore";

export const useToast = () => {
  const setLoading = useBoundStore((state) => state.toastAction.setLoading);

  return {
    Loading: (id = "LOADING", options = DefaultToastOptions) => {
      const loadMsg = getLoadMsg(id);
      setLoading(true);
      toast.loading(loadMsg, {
        ...options,
        toastId: id,
        hideProgressBar: true,
      });
    },

    FinishLoading: (
      id = "LOADING",
      type = "success",
      options = DefaultToastOptions
    ) => {
      const renderMsg = getRenderMsg(id, type);
      toast.update(id, {
        ...options,
        render: renderMsg,
        type,
        isLoading: false,
      });
      setLoading(false);
      setTimeout(() => {
        if (toast.isActive(id)) toast.dismiss(id);
      }, 5000);
    },

    CloseToast: (id) => {
      if (id) {
        toast.dismiss(id);
        setLoading(false);
        return;
      }
      toast.dismiss("ERROR");
      toast.dismiss("WARNING");
      toast.dismiss("SUCCESS");
      toast.dismiss("INFO");
      toast.dismiss("LOADING");
      setLoading(false);
    },

    Error: (message, options = DefaultToastOptions, id = "ERROR") =>
      toast.error(message, {
        ...options,
        toastId: id,
        hideProgressBar: true,
      }),

    Warning: (message, options = DefaultToastOptions, id = "WARNING") =>
      toast.warning(message, {
        ...options,
        toastId: id,
        hideProgressBar: true,
      }),

    Success: (message, options = DefaultToastOptions, id = "SUCCESS") =>
      toast.success(message, {
        ...options,
        toastId: id,
        hideProgressBar: true,
      }),

    Info: (message, options = DefaultToastOptions, id = "INFO") =>
      toast.info(message, {
        ...options,
        toastId: id,
        hideProgressBar: true,
      }),

    notificationInfo: (message, id = "NOTI") =>
      toast.info(message, {
        ...NotificationToastOptions,
        toastId: id,
        hideProgressBar: true,
      }),
    customNotificationInfo: (message, option = {}, id = "NOTI") =>
      toast.info(message, {
        ...NotificationToastOptions,
        toastId: id,
        hideProgressBar: true,
        ...option,
      }),
  };
};
